import React from 'react';
import { injectIntl } from 'react-intl';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import { SlideTransition } from '../../Transition/Transition';

const SaveWhiteboardJSONDialog = props => {
  const { intl, open, onClose, ...rest } = props;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth={true}
      {...rest}
      slots={{
        transition: SlideTransition
      }}>
      <DialogTitle>{intl.formatMessage({ id: 'whiteboard-save-json-dialog-title' })}</DialogTitle>
      <DialogContent>{intl.formatMessage({ id: 'whiteboard-save-json-dialog-content' })}</DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClose}>
          {intl.formatMessage({ id: 'OK' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default injectIntl(SaveWhiteboardJSONDialog);
